import { render, staticRenderFns } from "./Carousel3.vue?vue&type=template&id=086331c1&scoped=true&"
import script from "./Carousel3.vue?vue&type=script&lang=js&"
export * from "./Carousel3.vue?vue&type=script&lang=js&"
import style0 from "./Carousel3.vue?vue&type=style&index=0&id=086331c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086331c1",
  null
  
)

export default component.exports